import { type ProjectCode } from '@constants'
import { type CsvButlerItem } from '../../../hooks/use-stm-quick-order-store'

export interface CsvBrandGroup {
  projectCode: ProjectCode
  items: CsvButlerItem[]
}

const firstSourceRowNumber = (item: CsvButlerItem) => Math.min(...item.sourceRowNumbers)

const sortBySourceRowNumber = (items: CsvButlerItem[]) => [...items].sort((left, right) => firstSourceRowNumber(left) - firstSourceRowNumber(right))

/** 品牌順序由全部商品（含已刪除）決定，刪除商品不會讓品牌跳位 */
export const listCsvBrands = (items: CsvButlerItem[]): ProjectCode[] =>
  [...new Set(sortBySourceRowNumber(items).map(item => item.projectCode))]

/** 品牌順序同 listCsvBrands，區內商品依首次列號排序；商品全刪的品牌不產生區塊 */
export const groupCsvItemsByBrand = (items: CsvButlerItem[]): CsvBrandGroup[] => {
  const activeItems = sortBySourceRowNumber(items.filter(item => !item.isDeleted))

  return listCsvBrands(items).flatMap((projectCode) => {
    const brandItems = activeItems.filter(item => item.projectCode === projectCode)
    return brandItems.length ? [{ projectCode, items: brandItems }] : []
  })
}
